import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IoniconsFilled } from '@pt/pt-models';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { NgIf, NgStyle } from '@angular/common';

@Component({
  selector: 'pt-details-security-tool-type-supplier',
  standalone: true,
  template: `
    <div class="supplier">
      <div class="mb-3">
        <div class="input-group input-group-sm input-group-clickable">
          <input
            type="text"
            class="form-control cursor-pointer"
            readonly
            placeholder=""
            (click)="upload.click()"
            aria-describedby="bomHelp"
            [value]="currentFileName || ''"
          />
          <button
            class="btn btn-outline-secondary btn-sm"
            type="button"
            id="button-addon2"
            (click)="upload.click()"
          >
            <ion-icon
              name="{{ IconUpload }}"
              [ngStyle]="{ 'font-size': '12px' }"
              class="ion-icon"
              title=""
            ></ion-icon>
            {{ 'LABELS.BOM' | translate }}
          </button>
          <input
            id="file-input"
            #upload
            autocomplete="off"
            class="file-input d-none"
            type="file"
            (change)="changeListener($event)"
          />
        </div>
        <div
          id="bomHelp"
          *ngIf="bomFileErrorMessage"
          class="form-text"
          style="color: #990000aa;"
          [innerHTML]="bomFileErrorMessage"
        ></div>
      </div>
    </div>
  `,
  imports: [TranslateModule, IonicModule, NgStyle, NgIf],
  styles: [
    `
      .supplier {
        display: flex;
        margin: 5px 15px 0 20px;
      }

      .input-group-clickable input:hover {
        color: white;
        border-color: var(--bs-gray);
        background-color: var(--bs-gray);
      }
    `,
  ],
})
export class DetailsSecurityToolTypeSupplierComponent implements OnChanges {
  @Output() uploadBom = new EventEmitter<File>();
  @Input() bomFileErrorMessage?: string;
  @Input() bomFileName?: string;
  public IconUpload = IoniconsFilled.upload;
  public currentFileName?: string;
  private currentFile: File;

  ngOnChanges(changes: SimpleChanges): void {
    this.currentFileName = this.bomFileName;
  }

  changeListener($event): void {
    this.currentFile = $event.target.files[0] as File;
    this.currentFileName = this.currentFile.name;
    this.uploadBom.emit(this.currentFile);
  }
}
